import { gql } from '@apollo/client/core';

export const GET_TUNNEL_SESSION_URL = gql`
  query getTunnelSessionUrl($orgId: ID, $params: String, $path: String, $refreshToken: String) {
    getTunnelSessionUrl(orgId: $orgId, params: $params, path: $path, refreshToken: $refreshToken) {
      url
      iv
      auth
      ticket
    }
  }
`;
